import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
	container: { display: 'flex', justifyContent: 'center', padding: '20%' },
	img: { display: 'block', margin: '0px auto' }
});

export const EmptyComponent: React.FC = () => {
	const classes = useStyles();
	return (
		<div className={classes.container}>
			<img className={classes.img} src={require('../../assets/img/blueloader.gif')} />
		</div>
	);
};
